import axios from 'axios'

const api = axios.create({
  baseURL:'https://cross-do-prod.herokuapp.com/api'
})

export default api;
